module.exports = __webpack_public_path__ + "static/media/featured-image.fd676d7e.avif";